"use client";
import Image from "next/image";
//import Link from "next/link";
import Button from "@/Components/Button";
import { toWebp } from "@/utils/common";

interface softwareProps {
  data?: any;
}
const Visonary = ({ data }: softwareProps) => {
  
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="grid md:grid-cols-12 items-start w-full mb-[0]">
          <div className="sm:text-left xl:col-span-12 md:col-span-12">
            {data?.images?.data?.attributes?.url && (
              <Image
                src={toWebp(baseUrl + data?.images?.data?.attributes?.url)}
                alt=""
                className="w-full mb-[40px] "
                width={1230}
                height={488}
              />
            )}
          </div>
          <div className="sm:text-left xl:col-span-6 md:col-span-6">
            <h2 className="text-heading-1 font-bold text-primary-text sm:mb-[0] mb-[16px] md:mt-[0px] sm:max-w-[494px]  mx-0 w-full sm:text-left">
              {data?.title}
            </h2>
          </div>
          <div className="sm:text-left xl:col-span-6 md:col-span-6">
            <p className="text-heading-6 font-normal text-secondary-text   max-w-[940px] mx-auto">
              {data?.description}
            </p>

            {data?.cta?.label && data?.cta?.href && (
              <a href={data?.cta?.href} className="mt-[24px] flex mx-0 sm:justify-start justify-center">
                <Button label={data?.cta?.label} className="mt-[16px]" />
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visonary;
